import React, { Component } from 'react'
import {cl, globs, constant,getTime,getTimeI, copyToClipboard,
  dateToDisplayDate,
} from '../../components/utils/utils';
import C18Input00 from '../../usa/components/C18Input00';
import C18Button00 from '../../usa/components/C18Button00';
import {cleanMarkdown, getSuperUserFlags} from '../../usa/components/C18utils'
import Markdown from 'markdown-to-jsx'
import { changeSetpoint, wsTrans ,undoSetpoint, getSaveSetpoints, spGetNames} from '../../usa/utils/utils';
import C18SubMenuHeader00 from '../../usa/components/C18SubMenuHeader00';
import VoiceRecorder from '../../usa/components/UserVoice';
import { VolumeUp, Stop, Mic, Keyboard, Close } from "@material-ui/icons";
export default class ChatBotUI extends Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth < 768;
    const isCompactLayout = window.innerWidth <= 1024;
    this.state = {
      message: "",
      answer: "",
      question: "",
      host: "https://faiza-ai.link4cloud.com",
      lochost: "http://localhost:8000",
      loading: false,
      trainingMode: false,
      commandMode: false,
      chatHistory: [],
      type: undefined,
      isSpeaking: false,
      chatHeight: (isMobile) ? "60vh" : "68vh", // initial height
      viewportHeight: window.innerHeight, // Initialize with current height
      safePadding: 0,
      isIOS: false,
      // VOICE MODE: New state variables for continuous voice chat
      isVoiceMode: false, // Whether voice mode is active
      voiceState: 'idle', // 'idle' | 'listening' | 'thinking' | 'speaking' | 'paused'
      voiceTranscript: '', // Current voice transcript (live, shown as dashed bubble)
      voiceModeSupported: false, // Whether browser supports voice mode
      interimTranscript: '', // Live interim transcript while speaking
      chatHistory1: [
        {
              "question": "what is link4\n",
              "answer": "Link4 is a corporation that specializes in providing advanced environmental control solutions for the agricultural sector, particularly focusing on greenhouse operations. The company is known for its innovative technology that helps growers optimize their growing environments.\n\nKey features of Link4 include:\n\n1. **Pearl Controller**: One of their flagship products is the Pearl controller, an intelligent greenhouse environmental controller that integrates various systems such as irrigation, heating, cooling, lighting, and humidity control. This allows for efficient management of greenhouse conditions.\n\n2. **Cloud-Based Monitoring**: Link4 utilizes cloud technology to enable remote monitoring and management of greenhouse environments. This feature allows growers to access real-time data and control their systems from anywhere, enhancing operational efficiency.\n\n3. **User-Friendly Design**: The Pearl controller is designed to be flexible and easy to use, providing dynamic programming options that facilitate accurate greenhouse management.\n\n4. **Customer Support**: Link4 is committed to providing excellent customer service, with a well-trained support team available to assist users with their needs.\n\n5. **Target Market**: The company primarily serves small to midsize growers, offering cost-effective solutions that provide a high feature-to-price ratio.\n\nOverall, Link4 aims to improve the success of growers by providing intelligent control solutions that enhance plant growth and operational efficiency."
        },
        {
              "question": "what is par sensor\n",
              "answer": "A PAR (Photosynthetically Active Radiation) sensor is a device used to measure the amount of light available for photosynthesis in plants. It specifically measures light in the wavelength range of 400 to 700 nanometers, which is the spectrum of light that plants utilize for photosynthesis.\n\nKey features and functions of a PAR sensor include:\n\n1. **Light Measurement**: PAR sensors provide readings of light intensity, typically expressed in micromoles of photons per square meter per second (µmol/m²/s). This measurement helps growers understand how much light their plants are receiving.\n\n2. **Optimizing Growth Conditions**: By monitoring PAR levels, growers can adjust their lighting systems (such as grow lights) to ensure that plants receive the optimal amount of light for healthy growth and development.\n\n3. **Applications**: PAR sensors are commonly used in greenhouses, indoor farming, and research settings to assess light conditions and make informed decisions about lighting and plant care.\n\n4. **Integration with Control Systems**: Many modern environmental control systems, like the Pearl controller from Link4, can integrate PAR sensors to automate lighting adjustments based on real-time light measurements.\n\nOverall, PAR sensors are essential tools for growers to optimize light conditions for their plants, ultimately improving growth and yield."
          }
      ],
      feedBackQuestion: "",
      feedBackAnswer: "",
      pageType: 'Chat',
      documents: [],
      documentsLoading: false,
      docText: "",
      showToast: false,
      syncStatus: 'idle',
      syncMessage: '',
      isCommandExecuted: false,
      currentSetpointValue: "",
      commandModeChat: [],
      currentlyPlayingId: null,
      voiceWaveLevels: [0.15, 0.15, 0.15, 0.15, 0.15],
      isInitialized: false, // initialization flag
      isCompactLayout,
        // allQuestions: [],
        // alAnswers: []
    }

    // Bind methods
    this.updateViewportHeight = this.updateViewportHeight.bind(this)
    this.detectIOS = this.detectIOS.bind(this)
    this.calculateChatHeight = this.calculateChatHeight.bind(this)
    this.chatMessagesEndRef = React.createRef();
    this.subscribe_toKeyUp=globs.events.subscribe("keyUp",this.keyUp)
    this.username=globs?.user?.name||"You"
    this.menuItems = [
        {v:"Chat",e:"editReport",l:"viewReport",t:"Chat"},
      ]
      if ((getSuperUserFlags()&constant.SUPER_PRIVS_EDIT)!=0) this.menuItems.push(
        {v:"Documents",e:"editGraph",l:"viewGraph",t:"Documents"}
      )
      let av=globs?.user?.avatar
      // this.handleFeedback()
      if(av){
        this.path=`${constant.expressUrl}/usa/images/avatars/uploads/${av[0]}/${av[1]}/${av[2]}/${av.substr(3)}.jpeg`
      }else{
        this.path=`${constant.expressUrl}/usa/images/avatars/stockAvatar.jpg`
    }
    // hide scrollbar
    document.getElementById("sidebar-content").style.overflowY = "hidden"
    document.getElementById("sidebar-content").style.height = "87dvh"
    document.getElementById("sidebar-content").getElementsByClassName("inner")[0].style.overflowY = "hidden"
    document.getElementById("sidebar-content").getElementsByClassName("inner")[0].style.height = "100%"
    // add "refresh"
    this.subscribe_refreshEvent=globs.events.subscribe("RefreshLinkBot",this.refreshLinkbot)
    this.ttsGeneration = 0
    this.playbackMessageId = null
    this.ttsBlobByMessageId = {}
    this.ttsAudio = null
    this.audioPlaybackUnlocked = false
    this.lastSpokenTtsText = ''
    this.discardNextMediaRecording = false
    this.voiceRequestGeneration = 0
    this.voiceWaveRaf = null
    this.voiceMonitorStream = null
    this.voiceMonitorContext = null
    this.voiceWaveAnalyser = null
    this.voiceWaveFreqData = null
    this.mediaWaveAnalyser = null
    
    // VOICE MODE: Initialize speech recognition and synthesis
    this.recognition = null
    this.synthesis = window.speechSynthesis
    this.silenceTimer = null
    this.setupVoiceMode()
  }
  
  // VOICE MODE: Check browser support and initialize SpeechRecognition
  // CONTINUOUS MODE: Two engines supported
  //   'webspeech'     -> Chrome/Android. Uses browser SpeechRecognition (free, live interim transcript)
  //   'mediarecorder' -> iOS Safari fallback. Uses MediaRecorder + backend STT (/tts/stt) and TTS (/tts/voice)
  // this.voiceEngine is set here and read by startVoiceListening / exitVoiceMode / speakVoiceResponse
  setupVoiceMode = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
    const hasMediaRecorder = !!(window.MediaRecorder && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)

    if (SpeechRecognition && this.synthesis) {
      this.voiceEngine = 'webspeech'
      // CONTINUOUS MODE FIX: setupVoiceMode runs from constructor (pre-mount), where
      // setState() is silently dropped. Mutate this.state directly — this is the
      // documented pattern for initial state setup in the constructor.
      this.state.voiceModeSupported = true
      this.recognition = new SpeechRecognition()
      this.recognition.continuous = true
      this.recognition.interimResults = true // VOICE MODE: Enable live transcript
      this.recognition.lang = 'en-US'
      
      // VOICE MODE: Handle speech recognition results (live + final)
      this.recognition.onresult = (event) => {
        const { voiceState } = this.state
        // Ignore mic input while bot is processing or speaking (prevents TTS echo loops)
        if (voiceState === 'speaking' || voiceState === 'thinking') {
          return
        }

        let interimTranscript = ''
        let finalTranscript = ''
        
        // VOICE MODE: Process all results to get interim and final transcripts
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript
          if (event.results[i].isFinal) {
            finalTranscript += transcript
          } else {
            interimTranscript += transcript
          }
        }
        
        // VOICE MODE: Update live transcript (shown as dashed bubble)
        if (interimTranscript && voiceState === 'listening') {
          this.setState({ interimTranscript })
        }
        
        // VOICE MODE: Auto-submit when user stops speaking (final transcript)
        if (finalTranscript) {
          if (this.isLikelyBotEcho(finalTranscript)) {
            cl('Ignoring likely bot TTS echo:', finalTranscript)
            this.setState({ interimTranscript: '' })
            return
          }
          cl('Final transcript:', finalTranscript)
          this.stopVoiceCapture()
          this.setState({ interimTranscript: '' })
          this.handleVoiceModeSubmit(finalTranscript)
        }
      }
      
      // VOICE MODE: Handle recognition errors
      this.recognition.onerror = (event) => {
        cl('Speech recognition error:', event.error)
        if (event.error === 'no-speech') {
          // CRITICAL: Just set paused state, onend will not restart
          this.pauseVoiceListening()
        } else if (event.error === 'not-allowed') {
          // Permission denied - exit voice mode
          this.setState({ 
            showToast: true, 
            toastMsg: 'Microphone permission denied',
            voiceState: 'idle',
            interimTranscript: ''
          })
          this.hideToast()
          if (this.recognition) {
            this.recognition.abort()
          }
        } else if (event.error === 'aborted') {
          // User exited voice mode, ignore
        } else {
          // Other errors - log but don't break the loop
          cl('Recognition error, continuing:', event.error)
        }
      }
      
      // VOICE MODE: Speech start detection (user started speaking)
      this.recognition.onspeechstart = () => {
        if (this.state.voiceState !== 'listening') return
        cl('Speech started - detecting voice')
      }
      
      // VOICE MODE: Critical - Handle Chrome bug where onend fires unexpectedly
      // Restart recognition automatically if voice mode is active and not thinking/speaking
      this.recognition.onend = () => {
        cl('Recognition ended, voice mode active:', this.state.isVoiceMode, 'state:', this.state.voiceState)
        if (this.state.isVoiceMode && this.state.voiceState === 'listening') {
          // Auto-restart listening (Chrome stops recognition automatically after each result)
          setTimeout(() => {
            if (this.state.isVoiceMode && this.state.voiceState === 'listening') {
              try {
                this.recognition.start()
                cl('Auto-restarted recognition')
              } catch (error) {
                cl('Recognition already running, ignore:', error)
              }
            }
          }, 100)
        }
      }
    } else if (hasMediaRecorder) {
      // CONTINUOUS MODE: iOS Safari path — no SpeechRecognition, use MediaRecorder + backend STT/TTS
      this.voiceEngine = 'mediarecorder'
      // CONTINUOUS MODE FIX: direct mutation (see comment above)
      this.state.voiceModeSupported = true
    } else {
      this.voiceEngine = null
      this.state.voiceModeSupported = false
    }
  }

  normalizeVoiceText = (text) => {
    return String(text || '')
      .toLowerCase()
      .replace(/[^\w\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
  }

  isLikelyBotEcho = (transcript) => {
    const spoken = this.normalizeVoiceText(this.lastSpokenTtsText)
    const heard = this.normalizeVoiceText(transcript)
    if (!spoken || !heard || heard.length < 4) return false
    if (spoken === heard) return true
    if (spoken.includes(heard) || heard.includes(spoken)) return true

    const spokenWords = new Set(spoken.split(' ').filter(Boolean))
    const heardWords = heard.split(' ').filter(Boolean)
    if (!heardWords.length) return false
    const overlap = heardWords.filter((word) => spokenWords.has(word)).length / heardWords.length
    return overlap >= 0.6
  }

  // Stop mic capture for both voice engines without submitting partial audio.
  stopVoiceCapture = () => {
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer)
      this.silenceTimer = null
    }

    if (this.recognition) {
      try {
        this.recognition.abort()
      } catch (e) {}
    }

    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.discardNextMediaRecording = true
      try {
        this.mediaRecorder.stop()
      } catch (e) {}
    }

    try {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => track.stop())
        this.mediaStream = null
      }
    } catch (e) {}

    try {
      if (this.mediaAudioContext) {
        this.mediaAudioContext.close()
        this.mediaAudioContext = null
      }
    } catch (e) {}

    this.mediaRecorder = null
    this.mediaWaveAnalyser = null
    this.stopVoiceWaveMonitor()
  }

  computeVoiceWaveLevels = (freqData) => {
    const barCount = 5
    const bucketSize = Math.max(1, Math.floor(freqData.length / barCount))
    const levels = []

    for (let i = 0; i < barCount; i++) {
      let sum = 0
      const start = i * bucketSize
      for (let j = start; j < start + bucketSize; j++) {
        sum += freqData[j] || 0
      }
      const avg = sum / bucketSize / 255
      levels.push(Math.max(0.12, Math.min(1, avg * 2.4)))
    }

    return levels
  }

  updateVoiceWaveLevels = (analyser) => {
    if (!analyser) return
    if (!this.voiceWaveFreqData || this.voiceWaveFreqData.length !== analyser.frequencyBinCount) {
      this.voiceWaveFreqData = new Uint8Array(analyser.frequencyBinCount)
    }
    analyser.getByteFrequencyData(this.voiceWaveFreqData)
    const levels = this.computeVoiceWaveLevels(this.voiceWaveFreqData)
    this.setState({ voiceWaveLevels: levels })
  }

  runVoiceWaveMonitorLoop = () => {
    if (!this.state.isVoiceMode || this.state.voiceState !== 'listening') {
      this.stopVoiceWaveMonitor()
      return
    }

    if (this.voiceWaveAnalyser) {
      this.updateVoiceWaveLevels(this.voiceWaveAnalyser)
    } else if (this.mediaWaveAnalyser) {
      this.updateVoiceWaveLevels(this.mediaWaveAnalyser)
    }

    this.voiceWaveRaf = requestAnimationFrame(this.runVoiceWaveMonitorLoop)
  }

  startVoiceWaveMonitor = async () => {
    if (this.voiceWaveRaf) return

    if (this.voiceEngine === 'mediarecorder' && this.mediaWaveAnalyser) {
      this.voiceWaveRaf = requestAnimationFrame(this.runVoiceWaveMonitorLoop)
      return
    }

    if (this.voiceEngine !== 'webspeech') {
      this.voiceWaveRaf = requestAnimationFrame(this.runVoiceWaveMonitorLoop)
      return
    }

    try {
      if (!this.voiceMonitorStream) {
        this.voiceMonitorStream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
          video: false,
        })
      }

      const AudioCtx = window.AudioContext || window.webkitAudioContext
      if (this.voiceMonitorContext) {
        try { this.voiceMonitorContext.close() } catch (e) {}
      }
      this.voiceMonitorContext = new AudioCtx()
      const source = this.voiceMonitorContext.createMediaStreamSource(this.voiceMonitorStream)
      this.voiceWaveAnalyser = this.voiceMonitorContext.createAnalyser()
      this.voiceWaveAnalyser.fftSize = 256
      this.voiceWaveAnalyser.smoothingTimeConstant = 0.35
      source.connect(this.voiceWaveAnalyser)
      this.voiceWaveRaf = requestAnimationFrame(this.runVoiceWaveMonitorLoop)
    } catch (err) {
      cl('Voice wave monitor failed:', err)
    }
  }

  stopVoiceWaveMonitor = (resetLevels = true) => {
    if (this.voiceWaveRaf) {
      cancelAnimationFrame(this.voiceWaveRaf)
      this.voiceWaveRaf = null
    }

    if (this.voiceMonitorStream) {
      try { this.voiceMonitorStream.getTracks().forEach((track) => track.stop()) } catch (e) {}
      this.voiceMonitorStream = null
    }

    if (this.voiceMonitorContext) {
      try { this.voiceMonitorContext.close() } catch (e) {}
      this.voiceMonitorContext = null
    }

    this.voiceWaveAnalyser = null
    this.voiceWaveFreqData = null

    if (resetLevels) {
      this.setState({ voiceWaveLevels: [0.15, 0.15, 0.15, 0.15, 0.15] })
    }
  }

  // CONTINUOUS MODE (mediarecorder engine): open mic, record, auto-stop on silence,
  // then ship the blob to /tts/stt and route the transcript through handleVoiceModeSubmit.
  // Used on iOS Safari where SpeechRecognition is unavailable.
  startMediaRecorderListening = async () => {
    if (!this.state.isVoiceMode) return
    // Guard: don't start a new session if one is already running
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') return

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
      })
      this.mediaStream = stream

      // Pick a mime type the browser can record. iOS Safari prefers mp4; others webm/opus.
      let mimeType = 'audio/webm;codecs=opus'
      if (window.MediaRecorder.isTypeSupported && !window.MediaRecorder.isTypeSupported(mimeType)) {
        mimeType = window.MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : ''
      }
      const recorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream)
      this.mediaRecorder = recorder
      this.mediaMimeType = recorder.mimeType || mimeType || 'audio/webm'

      const audioChunks = []
      recorder.addEventListener('dataavailable', (event) => {
        if (event.data && event.data.size > 0) audioChunks.push(event.data)
      })

      recorder.addEventListener('stop', async () => {
        const shouldDiscard = this.discardNextMediaRecording
        this.discardNextMediaRecording = false

        // Always free the stream tracks + audio context
        try { stream.getTracks().forEach((t) => t.stop()) } catch (e) {}
        try { if (this.mediaAudioContext) { this.mediaAudioContext.close(); this.mediaAudioContext = null } } catch (e) {}

        if (shouldDiscard || audioChunks.length === 0) {
          if (this.state.isVoiceMode && this.state.voiceState === 'listening') {
            this.startMediaRecorderListening()
          }
          return
        }
        const audioBlob = new Blob(audioChunks, { type: this.mediaMimeType })
        // Skip near-silent blobs (avoid posting empty audio)
        if (audioBlob.size < 1000) {
          // Empty capture — go back to listening if still in voice mode
          if (this.state.isVoiceMode && this.state.voiceState !== 'paused') {
            this.startMediaRecorderListening()
          }
          return
        }
        await this.sendVoiceAudioToBackend(audioBlob)
      })

      // Silence detection (mirrors UserVoice.js)
      const AudioCtx = window.AudioContext || window.webkitAudioContext
      const audioContext = new AudioCtx()
      this.mediaAudioContext = audioContext
      const source = audioContext.createMediaStreamSource(stream)
      const analyser = audioContext.createAnalyser()
      analyser.fftSize = 2048
      source.connect(analyser)
      this.mediaWaveAnalyser = analyser

      const buffer = new Float32Array(analyser.fftSize)
      let silenceStart = null
      const silenceDuration = 2000   // 2s of silence triggers auto-stop
      const silenceThreshold = 0.02

      const checkSilence = () => {
        if (!this.state.isVoiceMode || this.state.voiceState !== 'listening') return
        if (!this.mediaRecorder || this.mediaRecorder.state !== 'recording') return
        analyser.getFloatTimeDomainData(buffer)
        const rms = Math.sqrt(buffer.reduce((sum, v) => sum + v * v, 0) / buffer.length)
        if (rms < silenceThreshold) {
          if (!silenceStart) silenceStart = Date.now()
          else if (Date.now() - silenceStart > silenceDuration) {
            cl('CONTINUOUS MODE: silence detected → auto-stop recording')
            this.stopMediaRecorderListening()
            return
          }
        } else {
          silenceStart = null
        }
        requestAnimationFrame(checkSilence)
      }

      recorder.start()
      this.setState({ voiceState: 'listening', voiceTranscript: '', interimTranscript: '' })
      this.startVoiceWaveMonitor()
      requestAnimationFrame(checkSilence)

      // Idle timeout — if user never speaks, drop to 'paused' (mirrors webspeech path 8s)
      if (this.silenceTimer) clearTimeout(this.silenceTimer)
      this.silenceTimer = setTimeout(() => {
        if (this.state.voiceState === 'listening') {
          cl('CONTINUOUS MODE: idle timeout → paused')
          this.pauseVoiceListening()
        }
      }, 8000)
    } catch (err) {
      cl('CONTINUOUS MODE: getUserMedia failed', err)
      if (err && err.name === 'NotAllowedError') {
        this.setState({ showToast: true, toastMsg: 'Microphone permission denied', voiceState: 'idle' })
        this.hideToast()
      } else {
        this.setState({ voiceState: 'paused' })
      }
    }
  }

  // CONTINUOUS MODE (mediarecorder engine): stop the recorder cleanly. The recorder's
  // 'stop' handler will then upload the blob to /tts/stt.
  stopMediaRecorderListening = () => {
    if (this.silenceTimer) { clearTimeout(this.silenceTimer); this.silenceTimer = null }
    try {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop()
      }
    } catch (e) {
      cl('CONTINUOUS MODE: stop error', e)
    }
  }

  // CONTINUOUS MODE (mediarecorder engine): POST recorded audio to backend STT, then
  // hand the transcript to handleVoiceModeSubmit (same downstream flow as webspeech).
  sendVoiceAudioToBackend = async (audioBlob) => {
    this.stopVoiceCapture()
    this.setState({ voiceState: 'thinking' })
    try {
      const formData = new FormData()
      const ext = (this.mediaMimeType || '').includes('mp4') ? 'mp4' : 'webm'
      formData.append('file', audioBlob, `recording.${ext}`)
      const response = await fetch(`${this.state.host}/api/v1/tts/stt`, { method: 'POST', body: formData })
      if (!response.ok) throw new Error('STT failed')
      const data = await response.json()
      const text = data && data.text ? String(data.text).trim() : ''
      if (text) {
        if (this.isLikelyBotEcho(text)) {
          cl('Ignoring STT echo of bot speech:', text)
          if (this.state.isVoiceMode) {
            this.setState({ voiceState: 'listening', interimTranscript: '' })
            this.startMediaRecorderListening()
          }
          return
        }
        // Mirror webspeech UX: show the captured text briefly in the interim bubble
        this.setState({ interimTranscript: text })
        await this.handleVoiceModeSubmit(text)
      } else {
        // Empty / garbage transcript — resume listening
        if (this.state.isVoiceMode) {
          this.setState({ voiceState: 'listening', interimTranscript: '' })
          this.startMediaRecorderListening()
        }
      }
    } catch (err) {
      cl('CONTINUOUS MODE: STT error', err)
      if (this.state.isVoiceMode) {
        this.setState({ voiceState: 'listening', interimTranscript: '' })
        this.startMediaRecorderListening()
      }
    }
  }

  refreshLinkbot=()=>{
    cl("refresh linkbot")
    // clear chat history to allow for a "clean slate"
    this.stopAudio()
    this.ttsBlobByMessageId = {}
    globs.chatBotHistory = []
    this.setState({chatHistory: []})
  }

  componentWillUnmount=()=>{
    this.subscribe_refreshEvent.remove();
    this.subscribe_toKeyUp.remove()
    // add scrollbar back?
    document.getElementById("sidebar-content").style = "overflow-y: scroll;";
    document.getElementById("sidebar-content").getElementsByClassName("inner")[0].style = "overflow-y: scroll;";
    // Missing cleanup for viewport listeners
    if (window.visualViewport) { 
      window.visualViewport.removeEventListener("resize", this.updateViewportHeight)
    } else {
      window.removeEventListener("resize", this.updateViewportHeight)
      window.removeEventListener("orientationchange", this.updateViewportHeight)
    }
    // Audio cleanup
    this.stopAudio();
    if (this.audio) {
      this.audio.removeEventListener('ended', this.audioEndHandler);
    }
    // VOICE MODE: Cleanup voice mode resources
    if (this.recognition) {
      this.recognition.stop()
    }
    if (this.synthesis) {
      this.synthesis.cancel()
    }
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer)
    }
    // CONTINUOUS MODE: Cleanup MediaRecorder engine resources
    try {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop()
      }
    } catch (e) {}
    try {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((t) => t.stop())
      }
    } catch (e) {}
    try {
      if (this.mediaAudioContext) {
        this.mediaAudioContext.close()
      }
    } catch (e) {}
    this.mediaRecorder = null
    this.mediaStream = null
    this.mediaAudioContext = null
    // CONTINUOUS MODE: clear synthesis watchdog interval
    if (this.voiceWatchdog) { clearInterval(this.voiceWatchdog); this.voiceWatchdog = null }
    this.stopVoiceWaveMonitor()
  }

  keyUp=(e)=>{
    if (e.key == "Enter" && !this.state.trainingMode && this.state.pageType == "Chat") {
      this.handleSubmitPrompt(e)
    } else if (e.key == "Enter" && this.state.pageType == "Documents") {
      this.handleSubmitDocument(e)
    }
  }

  loadInfo = async() => {
    let sesh=globs.userData.session
    //     cl(sesh)
    this.site=sesh.siteId
    this.zone=sesh.zoneId
    //     cl(globs.zonesInfo.info)
    //     cl(this.zone)
    let zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==this.zone})[0]
    //     cl(zone)
    if(zone){
      this.zoneIndex=zone.siteZoneIndex
      this.gwType=zone.gatewayType
      cl(this.site,this.zone,this.zoneIndex,this.gwType)
      // spGetNames(this.gwType, this.zoneIndex)
    }
  }

  componentDidMount() {
    // Initialize iOS detection first
    this.detectIOS()

    // Set up viewport listeners
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.updateViewportHeight)
    } else {
      window.addEventListener("resize", this.updateViewportHeight)
      window.addEventListener("orientationchange", this.updateViewportHeight)
    }
  
    // Auto-enable command mode on setpoints and temp_staging pages
    const isAICommandMode = window.location.pathname.includes("/setpoints/") || window.location.pathname.includes("/temp_Staging/") || window.location.pathname.includes("/hum_dehum/");
    if (isAICommandMode) {
      globs.commandMode = true;
    }

    // Calculate initial height and set initialized flag
    if (!globs.chatHeight) {
      if (this.chatMessagesEndRef.current) {
        globs.chatHeight = this.chatMessagesEndRef.current.offsetHeight
      }
    }
    this.setState({fixedHeight: globs.chatHeight})
    this.calculateChatHeight()

    // requestAnimationFrame to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      this.setState(
        {
          isCommandExecuted: false,
          isInitialized: true,
        },
        () => {
          this.scrollToBottom()
          // Recalculate height after initialization
          setTimeout(() => {
        this.calculateChatHeight()
         // Scroll again after height calculation
        this.scrollToBottom()
      }, 100)
        },
      )
    })
  }
 audioBufferToWavBlob=(audioBuffer) =>{
  const numChannels = audioBuffer.numberOfChannels;
  const sampleRate = audioBuffer.sampleRate;
  const length = audioBuffer.length * numChannels;
  const buffer = new ArrayBuffer(44 + length * 2); // 16-bit PCM
  const view = new DataView(buffer);

  // Write WAV header
  function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }

  let offset = 0;

  writeString(view, offset, 'RIFF'); offset += 4;
  view.setUint32(offset, 36 + length * 2, true); offset += 4; // file length
  writeString(view, offset, 'WAVE'); offset += 4;
  writeString(view, offset, 'fmt '); offset += 4;
  view.setUint32(offset, 16, true); offset += 4; // PCM format chunk size
  view.setUint16(offset, 1, true); offset += 2; // PCM format
  view.setUint16(offset, numChannels, true); offset += 2;
  view.setUint32(offset, sampleRate, true); offset += 4;
  view.setUint32(offset, sampleRate * numChannels * 2, true); offset += 4; // byte rate
  view.setUint16(offset, numChannels * 2, true); offset += 2; // block align
  view.setUint16(offset, 16, true); offset += 2; // bits per sample
  writeString(view, offset, 'data'); offset += 4;
  view.setUint32(offset, length * 2, true); offset += 4;

  // Write interleaved PCM samples
  const interleaved = new Float32Array(length);
  for (let channel = 0; channel < numChannels; channel++) {
    const channelData = audioBuffer.getChannelData(channel);
    for (let i = 0; i < audioBuffer.length; i++) {
      interleaved[i * numChannels + channel] = channelData[i];
    }
  }

  for (let i = 0; i < interleaved.length; i++, offset += 2) {
    let sample = Math.max(-1, Math.min(1, interleaved[i]));
    sample = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
    view.setInt16(offset, sample, true);
  }

  return new Blob([view], { type: 'audio/wav' });
}
  sliceAudioBlob = async (blob, chunkDuration = 5) => {
  const audioContext = new AudioContext();
  const arrayBuffer = await blob.arrayBuffer();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

  const sampleRate = audioBuffer.sampleRate;
  const totalChunks = Math.ceil(audioBuffer.duration / chunkDuration);
  const chunks = [];

  for (let i = 0; i < totalChunks; i++) {
    const start = i * chunkDuration * sampleRate;
    const end = Math.min((i + 1) * chunkDuration * sampleRate, audioBuffer.length);
    const frameCount = end - start;

    const chunkBuffer = audioContext.createBuffer(
      audioBuffer.numberOfChannels,
      frameCount,
      sampleRate
    );

    for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
      chunkBuffer
        .getChannelData(channel)
        .set(audioBuffer.getChannelData(channel).slice(start, end));
    }

    const chunkBlob = this.audioBufferToWavBlob(chunkBuffer);
    chunks.push(chunkBlob);
  }

  return chunks;
}
  playAudioChunksSequentially = async(blobChunks) => {
    const audio = new Audio();
    for (const chunk of blobChunks) {
      audio.src = URL.createObjectURL(chunk);
      await this.waitForEvent(audio, 'canplaythrough');
      await audio.play();
      await new Promise((res) => audio.onended = res);
      URL.revokeObjectURL(audio.src);
    }
  }
  detectIOS() {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    this.setState({ isIOS })
  }

  updateViewportHeight() {
    cl("update viewport height")
    let viewportHeight
    let safePadding = 0

    if (window.visualViewport) {
      viewportHeight = window.visualViewport.height
    } else {
      viewportHeight = window.innerHeight
    }
     
    if (this.state.isIOS) {
      try {
        const fullHeight = window.screen ? window.screen.height : window.innerHeight
        const currentHeight = viewportHeight
        if (currentHeight < fullHeight * 0.9) {
          safePadding = Math.max(0, 10)
        }
      } catch (error) {
        safePadding = 20
      }
    }
    // Debounce this function
    clearTimeout(this.viewportTimeout);
    const isCompactLayout = window.innerWidth <= 1024;
    this.viewportTimeout = setTimeout(() => {
      this.setState({
        viewportHeight,
        safePadding,
        isCompactLayout,
      }, 
      () => {
        this.calculateChatHeight()
      },
    )
    }, 100);
  }

  calculateChatHeight() {
    cl("calculate chat height")
    const { viewportHeight, isIOS, safePadding } = this.state

    const parts = window.location.pathname.split("/").filter(Boolean)
    const zonesIdx = parts.indexOf('zones');
    const depthAfterZones = zonesIdx === -1 ? -1 : parts.length - zonesIdx - 1;

    let chatHeight;

  const isMobile = window.innerWidth < 1600;
  // cl('Window width:', window.innerWidth);

    if (zonesIdx === -1 || depthAfterZones > 1) {
    // Site or deeper pages under zone
    chatHeight = isMobile ? '68dvh' : '60h';
    } else {
       // /zones or /zones/XYZ
    chatHeight = isMobile ? '68dvh' : '60vh';
    }
    this.loadInfo();

    // Adjust for iOS Safari if needed
    // if (isIOS && viewportHeight > 0 && isMobile) {
    //   const headerHeight = 120
    //   const inputAreaHeight = 200
    //   const calculatedHeight = viewportHeight - headerHeight - inputAreaHeight - safePadding

    //   if (calculatedHeight > 200) {
    //     chatHeight = `${calculatedHeight}px`
    //   }
    // }

    // Only update state if height actually changed
    // if (this.state.chatHeight !== chatHeight) {
    //   this.setState({ chatHeight, isCommandExecuted: false})
    // }
  }

  scrollToBottom = () => {
  if (this.chatMessagesEndRef.current) {
    // Clear any pending scroll operations
    if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
    // Use setTimeout to ensure DOM is updated
    setTimeout(() => {
      if (this.chatMessagesEndRef.current) {
        this.chatMessagesEndRef.current.scrollTo({
          top: this.chatMessagesEndRef.current.scrollHeight,
      behavior: 'smooth'
    });
      }
    }, 100)
  }
}

  componentDidUpdate(prevProps, prevState) {
    // check globs.chatBotHistory length changed from previous
    if (prevState.chatHistory.length !== this.state.chatHistory.length) {
    this.scrollToBottom();
    }

  // Also handle the "thinking..." to answer transition
  if (this.state.chatHistory.some((item, index) => 
    prevState.chatHistory[index]?.answer === "thinking..." && 
    item.answer !== "thinking..."
  )) {
    this.scrollToBottom();
    }
  }
    // Function to handle input change
  handleInputChange = (event, pageType) => {
        // cl("🚀 ~ ChatBotUI ~ event:", event, pageType)
        if (pageType == "Chat")
        this.setState({ message: event.target.value, question: event.target.value });
        else if (pageType == "Documents")
        this.setState({ docText: event.target.value });
  }
    handleTypeChange = async (val, ind,  question, answer) => {
      cl("im in handletypechange")
      this.setState({ type: val, feedBackQuestion:question, feedBackAnswer: answer });
  //     await this.handleFeedback()
  // }
      const ch = this.state.chatHistory;
    const updatedCH = ch.map((c, i) => {
        if(i === ind){
        c.type = val
      }
      return c
    })
    // update globs with chat history
    globs.chatBotHistory[ind].type = val
      this.setState({chatHistory: [...updatedCH]})

  //   handleFeedback= async () => {
      const { feedBackAnswer, feedBackQuestion, type } =  this.state
    const body = {
      question: question,
      answer: answer,
        type: val // 0 for thumbsdown n 1 for thumbs up
      };
      // cl("🚀 ~ ChatBotUI ~ handleFeedback= ~ body:", body)
      let feedback = await wsTrans("usa", {
        cmd: "cRest", uri: "/s/aiFeedback", method: "create",
        sessionId: globs.userData.session.sessionId, body

    })

  }
  hideToast = () => {
    setTimeout(() => {
        this.setState({ showToast: false, toastMsg: ''});
      }, 3000);
  }
  hideSyncFeedback = () => {
    setTimeout(() => {
      this.setState({ syncStatus: 'idle', syncMessage: '' });
    }, 3000);
  }
  renderDocSyncAction = () => {
    const { syncStatus, syncMessage } = this.state;
    if (syncStatus === 'done' && syncMessage) {
      return (
        <span className="chatbot-sync-success cb-doc-sync-feedback" role="status">
          <span className="material-icons-outlined chatbot-sync-success-icon">check_circle</span>
          {syncMessage}
        </span>
      );
    }
    const isSyncing = syncStatus === 'syncing';
    return (
      <button
        type="button"
        className={`cb-doc-sync-btn${isSyncing ? ' cb-doc-sync-btn--syncing' : ''}`}
        onClick={this.trainBotWithDocuments}
        disabled={isSyncing}
        title="Sync Google Docs with chatbot"
      >
        <span className="material-icons-outlined cb-doc-sync-icon">sync</span>
        {isSyncing ? 'Syncing…' : 'Sync Docs'}
      </button>
    );
  }
  renderDocUploadAction = () => (
    <div className="cb-doc-upload-wrap">
      <C18Button00
        type="button"
        className="cb-doc-upload-btn material-icons-outlined"
        aria-label="Upload document"
      >
        attach_file
      </C18Button00>
      <C18Input00
        id="/sidebar/ai/header/attach"
        type="file"
        multiple
        onChange={this.handleImage}
        className="cb-doc-upload-input"
      />
    </div>
  )
  handleVoiceTranscript = (text) => {
  this.setState({
    message: text,
    question: text
  }, () => {
    // Automatically submit after a small delay
    setTimeout(() => {
      this.handleSubmitPrompt({ preventDefault: () => {} });
    }, 600);
  });
};
  // Safari/iOS: unlock HTMLAudioElement during a user gesture so later TTS can autoplay
  unlockAudioPlayback = () => {
    if (!this.ttsAudio) {
      this.ttsAudio = new Audio();
      this.ttsAudio.playsInline = true;
      this.ttsAudio.setAttribute("playsinline", "");
    }
    const silentSrc =
      "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
    if (this.ttsAudio.src !== silentSrc) {
      this.ttsAudio.src = silentSrc;
    }
    const playPromise = this.ttsAudio.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(() => {
          this.audioPlaybackUnlocked = true;
          this.ttsAudio.pause();
          this.ttsAudio.currentTime = 0;
        })
        .catch(() => {});
    }
  };

 stopPlaybackOnly = () => {
  const audio = this.audio || this.ttsAudio;
  if (audio) {
    audio.pause();
    audio.currentTime = 0;
    audio.onended = null;
  }
  this.audio = null;
  if (this.audioObjectUrl) {
    URL.revokeObjectURL(this.audioObjectUrl);
    this.audioObjectUrl = null;
  }
};

 stopAudio = () => {
  this.ttsGeneration += 1;
  this.playbackMessageId = null;
  this.stopPlaybackOnly();
  this.clearVoiceWatchdog();
  if (this.synthesis) {
    try { this.synthesis.cancel(); } catch (e) {}
  }
  this.setState({ isSpeaking: false, currentlyPlayingId: null });
};

  clearVoiceWatchdog = () => {
    if (this.voiceWatchdog) {
      clearInterval(this.voiceWatchdog);
      this.voiceWatchdog = null;
    }
  }

  resumeListeningAfterVoiceTts = () => {
    if (!this.state.isVoiceMode) return;
    this.setState({ voiceState: 'listening', interimTranscript: '' });
    this.startVoiceListening();
  }

  getCachedTtsBlob = (messageId, text) => {
    const entry = this.ttsBlobByMessageId[messageId];
    return entry && entry.text === text ? entry.blob : null;
  };

  // Single TTS request shape — voice/gender is configured on the backend, not in the browser.
  buildTtsRequestPayload = (plainText) => ({ text: plainText })

  fetchTtsAudioBlob = async (text, voiceRequestId) => {
    if (!text || !String(text).trim()) return null
    if (voiceRequestId != null && voiceRequestId !== this.voiceRequestGeneration) {
      return null
    }

    const response = await fetch(`${this.state.host}/api/v1/tts/voice`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.buildTtsRequestPayload(text)),
    })

    if (voiceRequestId != null && voiceRequestId !== this.voiceRequestGeneration) {
      return null
    }
    if (!response.ok) {
      throw new Error("TTS API failed")
    }

    const audioBlob = await response.blob()
    if (voiceRequestId != null && voiceRequestId !== this.voiceRequestGeneration) {
      return null
    }
    return audioBlob
  }

  // Shared resolver: text mode, voice mode, and speaker replay all use this path.
  resolveTtsAudioBlob = async (cleanText, messageId, { ttsPrefetchPromise = null, voiceRequestId = null } = {}) => {
    const cached = this.getCachedTtsBlob(messageId, cleanText)
    if (cached) return cached

    let audioBlob = null
    if (ttsPrefetchPromise) {
      audioBlob = await ttsPrefetchPromise
    } else {
      audioBlob = await this.fetchTtsAudioBlob(cleanText, voiceRequestId)
    }

    if (audioBlob) {
      this.ttsBlobByMessageId[messageId] = { text: cleanText, blob: audioBlob }
    }
    return audioBlob
  }

  // Start TTS fetch early and cache the blob as soon as it arrives.
  prefetchVoiceTts = (text, messageId, voiceRequestId) => {
    const promise = this.fetchTtsAudioBlob(text, voiceRequestId)
    promise.then((blob) => {
      if (!blob || voiceRequestId !== this.voiceRequestGeneration) return
      this.ttsBlobByMessageId[messageId] = { text, blob }
    }).catch(() => {})
    return promise
  }

  playTtsAudioBlob = async (audioBlob, session) => {
    if (!audioBlob || session !== this.ttsGeneration) {
      return
    }

    this.stopPlaybackOnly()
    this.audioObjectUrl = URL.createObjectURL(audioBlob)

    if (!this.ttsAudio) {
      this.ttsAudio = new Audio()
      this.ttsAudio.playsInline = true
      this.ttsAudio.setAttribute("playsinline", "")
    }

    const audio = this.ttsAudio
    this.audio = audio
    audio.preload = "auto"
    audio.src = this.audioObjectUrl
    audio.onended = () => {
      if (session !== this.ttsGeneration) {
        return
      }
      if (this.audioObjectUrl) {
        URL.revokeObjectURL(this.audioObjectUrl)
        this.audioObjectUrl = null
      }
      this.audio = null
      this.playbackMessageId = null
      this.setState({ isSpeaking: false, currentlyPlayingId: null })
      if (this.state.isVoiceMode) {
        cl('CONTINUOUS MODE: TTS ended → resume listening (engine=' + this.voiceEngine + ')')
        this.resumeListeningAfterVoiceTts()
      }
    }

    if (session !== this.ttsGeneration) {
      return
    }

    try {
      await audio.play()
    } catch (playErr) {
      await Promise.race([
        this.waitForEvent(audio, "canplay"),
        new Promise((resolve) => setTimeout(resolve, 400)),
      ])
      if (session !== this.ttsGeneration) {
        return
      }
      await audio.play()
    }
  }

  speakWithServerTts = async (cleanText, messageId, session, ttsPrefetchPromise = null, voiceRequestId = null) => {
    const audioBlob = await this.resolveTtsAudioBlob(cleanText, messageId, { ttsPrefetchPromise, voiceRequestId })

    if (session !== this.ttsGeneration) {
      return
    }
    if (!audioBlob) {
      if (this.state.isVoiceMode) {
        this.setState({ voiceState: 'listening', isSpeaking: false, currentlyPlayingId: null })
        this.startVoiceListening()
      }
      return
    }

    await this.playTtsAudioBlob(audioBlob, session)
  }

waitForEvent = (el, eventName) => {
    return new Promise((resolve) => {
      const handler = (e) => {
        el.removeEventListener(eventName, handler);
        resolve(e);
      };
      el.addEventListener(eventName, handler);
    });
  }
  waitForCanPlayThrough = (audio, timeoutMs = 5000) => {
  return new Promise((resolve, reject) => {
    const onReady = () => {
      cleanup();
      resolve();
    };

    const onError = () => {
      cleanup();
      reject(new Error('Audio failed to load or decode'));
    };

    const onTimeout = () => {
      cleanup();
      reject(new Error('Timeout waiting for canplaythrough'));
    };

    const cleanup = () => {
      audio.removeEventListener('canplaythrough', onReady);
      audio.removeEventListener('error', onError);
      clearTimeout(timer);
    };

    audio.addEventListener('canplaythrough', onReady, { once: true });
    audio.addEventListener('error', onError, { once: true });
    const timer = setTimeout(onTimeout, timeoutMs);
  });
}
handleReadLoud = async (text, messageId) => {
  if (this.playbackMessageId === messageId) {
    if (this.state.isVoiceMode) {
      this.interruptBotAndStartListening()
    } else {
      this.stopAudio()
    }
    return
  }

  const cleanText = cleanMarkdown(text);
  if (!cleanText || !String(cleanText).trim()) {
    return;
  }

  const session = ++this.ttsGeneration;
  this.stopPlaybackOnly();

  if (this.state.isVoiceMode) {
    this.lastSpokenTtsText = cleanText
    this.stopVoiceCapture()
    this.stopVoiceWaveMonitor()
  }

  this.unlockAudioPlayback();
  this.playbackMessageId = messageId;
  this.setState({
    isSpeaking: true,
    currentlyPlayingId: messageId,
    ...(this.state.isVoiceMode
      ? { voiceState: 'speaking', interimTranscript: '' }
      : {}),
  });

  try {
    await this.speakWithServerTts(cleanText, messageId, session);
  } catch (err) {
    if (session !== this.ttsGeneration) return
    cl(this.state.isVoiceMode ? 'Voice mode read-aloud failed:' : 'TTS failed:', err)
    this.playbackMessageId = null
    this.setState({
      isSpeaking: false,
      currentlyPlayingId: null,
      ...(this.state.isVoiceMode ? { voiceState: 'listening' } : {}),
    })
    if (this.state.isVoiceMode) {
      this.startVoiceListening()
    }
  }
};

  handleVoiceSend = (text) => {
      this.setState({
        message: text,
        question: text
      }, () => {
        // reuse your existing submit logic
        this.handleSubmitPrompt({ preventDefault: () => {} });
      });
  }

  handleCmd = async (aiResp) => {
        let cmds={
          // openZone:this.openZone,
          // openPage:this.openPage,
          // text:this.gotText,
          changeSetpoint:changeSetpoint,
      undoSetpoint: undoSetpoint,
    }
        if(cmds[aiResp.cmd]){
      cmds[aiResp.cmd](aiResp, this.gwType, this.zoneIndex)
      cl("🚀 ~ ChatBotUI ~ handleCmd after changing setpoints")
          this.setState({ isCommandExecuted: true });
          return "Command executed successfully";
        }else{
      cl(`unknown cmd: ${aiResp.cmd}`)
          return "Unknown command";
    }

      
  }
  makeCmdName = (toolName) => {
     // check toolname has word retrieve or change then replace it
     if(toolName.includes("retrieve_setpoints")){
      return "retrieveSetpoint"
    } else if(toolName.includes("change_setpoints")) {
      return "changeSetpoint";
    }
  }

  makeLinkBotErrorMsg = (msg) => {
    if (globs.chatBotHistory[globs.chatBotHistory.length - 1]) globs.chatBotHistory[globs.chatBotHistory.length - 1].answer = msg;
    this.setState(prevState => {
      const updatedChatHistory = [...prevState.chatHistory];
      if (updatedChatHistory[updatedChatHistory.length - 1]) {
        updatedChatHistory[updatedChatHistory.length - 1].answer = msg;
      } 
    return {
      loading: false,
            chatHistory: updatedChatHistory
          };
        });
  }
getPageTypeFromURL = () => {
  const path = window.location.pathname.toLowerCase();

  if (path.includes("/setpoints/")) return "setpoints";
  if (path.includes("/temp_staging/")) return "temp_stages";
  if (path.includes("/HumDeHum/")) return "hum_dehum";

  return "";
};
  loadPageData=async(pageType)=>{
    cl(" glob.tempStagesInfo", globs.tempStagesInfo, " glob.tempStagesInfoparms", globs.tempStagesInfoparms )
    switch(pageType){
      case "setpoints":
        const spData = await getSaveSetpoints(this.zoneIndex)
        return spData;
      case "temp_stages":
        await new Promise(resolve => setTimeout(resolve, 100))
        return {info: globs?.tempStagesInfo, parms: globs?.tempStagesInfoparms, user: globs?.user?.userId, sessionId: globs?.userData?.session?.sessionId};
      default:
        return [];
    }

  }
  handleSubmitPrompt = async (e) => {
   const pageType = this.getPageTypeFromURL();

    try {
    e.preventDefault()
        let msg = this.state.message
        if(msg === "") return

        // INTERRUPTION: Stop any playing audio/speech when user submits new message
        console.log('[Submit] New message submitted - stopping any playing audio');
        this.stopAudio(); // Stop TTS audio playback
        this.unlockAudioPlayback();
        if (this.synthesis) {
          this.synthesis.cancel(); // Stop speech synthesis
          console.log('[Submit] Speech synthesis cancelled');
        }
        
        let quest = this.state.question
        let type = this.state.type

    // const data = await this.pageData(pageType)
    let data =[]
    data = await this.loadPageData(pageType)

    // cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ pageData:", data, pageType, this.state.commandMode, globs.commandMode)
    // Auto-enable command mode on setpoints and temp_staging pages
    const isAICommandMode = pageType === "setpoints" || pageType === "temp_stages" || pageType === "hum_dehum";
    if (isAICommandMode) {
      globs.commandMode = true;
    } else {
      globs.commandMode = false
    }

    // const body = globs.commandMode
    //     ? { messages: [{ role: "user", content: msg }], type: "command", data: data, thread_id: (globs.userData.session.sessionId).toString(), pageType: pageType}
    //     : { message: msg, question: quest };
     const body = { messages: [{ role: "user", content: msg }], type: "command", data: data, thread_id: (globs.userData.session.sessionId).toString(), pageType: pageType}
    //     : { message: msg, question: quest };
        cl(body)

    // update globs with chat history
    globs.chatBotHistory.push({question: quest, answer: "thinking...", type: undefined})

    this.setState({
      question: this.state.message,
      message: "",
      loading: true,
          chatHistory: [...this.state.chatHistory, {question: quest, answer: "thinking...", type: undefined}],
          // CommandModeChat: this.state.commandMode ? [...this.state.CommandModeChat, { role: "user", content: msg }] : []
    })

        // call prompt api
        let apiUrl = "";
    let resp = ""
      if(this.state.trainingMode) 
    {

       apiUrl = `${this.state.host}/api/v1/prompt/train` 
      try {
        const resp = await fetch(apiUrl, {
              method: 'POST',
          headers: {
                'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })
        if (!resp.ok) {
              throw new Error("Server Error");
        }
        const toastMsg = this.state.trainingMode ? "Response submitted" : ""
        const response = await resp.json()
        const { question, answer } = response
          const newAnswer = this.state.trainingMode ? msg : answer;
          // const newChatHistory = [...chatHistory, {question, answer: newAnswer, type: undefined}]
          // Update globs with chat history
          // Update the chat history with the new answer
          cl("newAnswer", newAnswer)
          if(newAnswer && typeof newAnswer === "string") {
            await this.handleReadLoud(newAnswer, globs.chatBotHistory.length - 1)
          }
          this.setState(prevState => {
            const updatedChatHistory = [...prevState.chatHistory];
            globs.chatBotHistory[globs.chatBotHistory.length - 1].answer = newAnswer;
            // Update the last question with the received answer
            if (updatedChatHistory[updatedChatHistory.length - 1]) {
              updatedChatHistory[updatedChatHistory.length - 1].answer = newAnswer;
            }

          return {
            question: quest,
            answer: newAnswer,
              // trainingMode: prevState.trainingMode,
            trainingMode: false,
            message: "",
            loading: false,
            chatHistory: updatedChatHistory,
            showToast: true,
              toastMsg
            };
          });
        this.hideToast()
      } catch (error) {
        this.makeLinkBotErrorMsg("Linkbot is offline. Please try later.");
      }

    } else {
      
          apiUrl = `${this.state.host}/api/v1/lgvc/prompt`
          // let botCommandResp = await wsTrans("usa", {
          //   cmd: "cRest", uri: "/s/linkBot", method: "post",
          //   sessionId: globs.userData.session.sessionId, body: body
          // })
          // if(!botCommandResp?.data) {return}
          // const botMessages = botCommandResp.data || [];
          let botCommandResp = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          })
          const botResp = await botCommandResp.json();
          // cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ botResp:", botResp)
          const botMessages = botResp.messages || [];

      // cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ botMessages:", botMessages)

          // Find the latest 'tool' message with status 'pending'
      const toolMsgIndex = botMessages.findIndex(
            msg => msg.role === "tool" && msg.input && msg.input.status === "pending"
          );

      if (toolMsgIndex !== -1) {
            const toolMsg = botMessages[toolMsgIndex];
            const args = toolMsg.input.tool_input;

            const toolName = toolMsg.input.tool;
        cl(toolName)
        const cmd = this.makeCmdName(toolName)

        cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ args:", args, cmd)

            args.cmd = cmd // default command
            // args.value = "9"
            resp = this.handleCmd(args);
                // Mark this tool message as done
        // botMessages[toolMsgIndex] = {
        //   ...toolMsg,
        //   input: {
        //     ...toolMsg.input,
        //         status: "done"
        //       }
        //     };
            cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ resp:",this.state.isCommandExecuted, resp)
      }

          // call here
      // Update the last item in globs.chatBotHistory with the last botMessages content
      
      const lastBotMsg = botMessages[botMessages.length - 1];
      if (lastBotMsg && typeof lastBotMsg.content === "string") {
        await this.handleReadLoud(lastBotMsg.content, globs.chatBotHistory.length - 1);
      }
      cl("audio loaded text ", lastBotMsg.content)
      this.setState(prevState => {
        const updatedChatHistory = [...prevState.chatHistory];
        globs.chatBotHistory[globs.chatBotHistory.length - 1].answer = botMessages[botMessages.length - 1].content ?? "Linkbot is offline. Please try later.";
        // Update the last question with the received answer
        if (!updatedChatHistory[updatedChatHistory.length - 1]) return
        updatedChatHistory[updatedChatHistory.length - 1].answer = botMessages[botMessages.length - 1].content;

      return {
        question: quest,
          // trainingMode: prevState.trainingMode,
        trainingMode: false,
        message: "",
        loading: false,
        chatHistory: updatedChatHistory,
        session_id: globs.userData.session.sessionId,
          // CommandModeChat: [...prevState.CommandModeChat, { role: "assistant", content: botMessages[botMessages.length - 1].content }], 
        showToast: true,
          // toastMsg: "Command executed successfully"
        isCommandExecuted: false,
        };
      });
    }

    } catch (error) {
      cl("🚀 ~ ChatBotUI ~ handleSubmitPrompt= ~ error:", error);
      this.makeLinkBotErrorMsg("Linkbot is offline. Please try later.");
    }

  }

    handleTrainingToggle= async e => {
    const tm = this.state.trainingMode
      this.setState({ trainingMode: !tm });

  }
  handleCommandToggle = () => {
  globs.commandMode = !this.state.commandMode
  this.setState(prevState => ({
    commandMode: !prevState.commandMode
  }));
};
  handleSubmitDocument = (e) => {
      e.preventDefault();
  }

    handleImage = async e => {
      const files = e.target.files;
    if (!files[files.length - 1]) return
      if (files[files.length - 1].size > (104857600)) return

      const formData = new FormData();

      // open for multiple files
      // for(let i=0;i<files.length;i++){
      //   let file = files[i]
      //   let name=file.name
      //   let ext=name.substring(name.lastIndexOf("."))
      //   cl("🚀 ~ ChatBotUI ~ ext:", name)
      //   formData.append('file', file);
      // }
      formData.append('file', files[0]);
      const fileName = files[0].name;
    try {
        // Example API call to upload files
      const response = await fetch(`${this.state.host}/api/v1/prompt/upload`, {
          method: 'POST',
        body: formData,
        });
        const data = await response.json();
      const documents = this.state.documents
        documents.push({"name": fileName, "type": "local", "path": `https://faiza-ai.link4cloud.com/files/${fileName}`})
        this.setState({ documents: documents });
        // cl('Upload Success:', data);
    } catch (error) {
        cl('Upload Error:', error);
    }
  }

    // fetchDocuments = async () => {
    //   this.setState({ documentsLoading: true });
    //   try {
    //     const response = await fetch(`${this.state.host}/api/v1/prompt/documents`, {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //     });
    //     const data = await response.json();
    //     // cl("🚀 ~ ChatBotUI ~ fetchDocuments= ~ data:", data)
    //     this.setState({ 
    //       documents: data.documents,
    //       documentsLoading: false 
    //     });
    //   } catch (error) {
    //     cl('Error fetching documents:', error);
    //     this.setState({ documentsLoading: false });
    //   }
    // }
    fetchDocuments = async (src="") => {
      this.setState({ documentsLoading: true });
    try {
      const response = await fetch(`${this.state.host}/api/v1/prompt/all_documents`, {
          method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        });
        const data = await response.json();
      cl("🚀 ~ ChatBotUI ~ fetchDocuments= ~ data:", data)
      this.setState({
        documents: data.documents ?? [],
        documentsLoading: false,
        showToast: src === "btn" ? true : false,
          toastMsg: src === "btn" ? "Documents loaded": ""
        });
      this.hideToast()
    } catch (error) {
        cl('Error fetching documents:', error);
        this.setState({ documentsLoading: false });
    }
  }
  trainBotWithDocuments = async () => {
    if (this.state.syncStatus === 'syncing') return;
    this.setState({ syncStatus: 'syncing', documentsLoading: true });
    try {
      const response = await fetch(`${this.state.host}/api/v1/prompt/train_with_google_docs`, {
          method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        });
        const data = await response.json();
      cl("🚀 ~ ChatBotUI ~ trainBotWithDocuments= ~ data:", data)
      this.setState({
        syncStatus: 'done',
        syncMessage: "Synced with Google Docs",
        documentsLoading: false,
      });
      this.hideSyncFeedback()
    } catch (error) {
        cl('Error fetching documents:', error);
        this.setState({ syncStatus: 'idle', documentsLoading: false });
    }
  }
    onChange=async(o) => {
      this.setState({ pageType: o.pageType, docText: "" });
      if (o.pageType === 'Documents' && this.state.documents.length === 0) {
        await this.fetchDocuments();
    }
  }
  handleLoadDocument = (doc) => {
      // cl("🚀 ~ ChatBotUI ~ doc:", doc)
    if (doc.name.match(/\.txt$/)) {
        this.setState({ docText: doc.text });
    }
  }
  handleDeleteDocument = async (doc) => {
    const url = `${this.state.host}/api/v1/prompt/delete-file?filename=${doc.name}`
    try {
      const delResult = await fetch(url, {
        method: 'DeLETE',
        body: JSON.stringify({docId: doc.name})
      })
        const documents = this.state.documents.filter((d) => d.name !== doc.name);

        this.setState({documents, toastMsg: "Document deleted", showToast: true});
      this.hideToast()
    } catch (error) {
        cl('Error deleting document:', error);
    }

  }
  
  // VOICE MODE: Enter continuous voice chat mode
  enterVoiceMode = () => {
    console.log('[VoiceMode] enterVoiceMode called. supported=', this.state.voiceModeSupported, 'engine=', this.voiceEngine)
    if (!this.state.voiceModeSupported) {
      console.log('[VoiceMode] BLOCKED — voiceModeSupported is false')
      this.setState({
        showToast: true,
        toastMsg: 'Voice chat not supported on this browser'
      })
      this.hideToast()
      return
    }
    
    // Stop any currently playing audio
    this.stopAudio()
    this.unlockAudioPlayback()

    // Enter voice mode and start listening
    this.setState({ 
      isVoiceMode: true, 
      voiceState: 'listening',
      voiceTranscript: ''
    }, () => {
      this.startVoiceListening()
    })
  }
  
  // VOICE MODE: Exit voice mode and return to normal chat
  exitVoiceMode = () => {
    // CRITICAL: Use abort() not stop() to fully terminate recognition
    if (this.recognition) {
      this.recognition.abort()
      cl('Recognition aborted on exit')
    }

    // CONTINUOUS MODE: Tear down MediaRecorder + audio context + stream tracks if active
    try {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop()
      }
    } catch (e) {}
    try {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((t) => t.stop())
        this.mediaStream = null
      }
    } catch (e) {}
    try {
      if (this.mediaAudioContext) {
        this.mediaAudioContext.close()
        this.mediaAudioContext = null
      }
    } catch (e) {}
    this.mediaRecorder = null

    // Stop speaking
    if (this.synthesis) {
      this.synthesis.cancel()
    }
    // Stop any server TTS playback as well (used by mediarecorder engine)
    this.stopAudio()

    // Clear silence timer
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer)
      this.silenceTimer = null
    }
    // CONTINUOUS MODE: clear synthesis watchdog interval
    if (this.voiceWatchdog) { clearInterval(this.voiceWatchdog); this.voiceWatchdog = null }
    this.stopVoiceWaveMonitor()

    // Reset state
    this.setState({
      isVoiceMode: false,
      voiceState: 'idle',
      voiceTranscript: '',
      interimTranscript: ''
    })
  }
  
  // VOICE MODE: Start listening for voice input
  // CONTINUOUS MODE: Router — picks engine based on this.voiceEngine
  startVoiceListening = () => {
    if (!this.state.isVoiceMode) return

    // CONTINUOUS MODE: iOS Safari path
    if (this.voiceEngine === 'mediarecorder') {
      this.startMediaRecorderListening()
      return
    }

    // Original webspeech path (Chrome/Android)
    if (!this.recognition) return
    try {
      this.recognition.start()
      this.setState({
        voiceState: 'listening',
        voiceTranscript: '',
        interimTranscript: ''
      })

      // VOICE MODE: Set silence timeout (8 seconds)
      if (this.silenceTimer) {
        clearTimeout(this.silenceTimer)
      }
      this.silenceTimer = setTimeout(() => {
        if (this.state.voiceState === 'listening' && !this.state.interimTranscript) {
          this.pauseVoiceListening()
          cl('Silence timeout - paused, will not auto-restart')
        }
      }, 8000)
      this.startVoiceWaveMonitor()
    } catch (error) {
      cl('Error starting recognition:', error)
      // Recognition might already be running, ignore
    }
  }
  
  pauseVoiceListening = () => {
    this.stopVoiceWaveMonitor()
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer)
      this.silenceTimer = null
    }

    if (this.voiceEngine === 'mediarecorder') {
      this.discardNextMediaRecording = true
      try {
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop()
        }
      } catch (e) {}
    } else if (this.recognition) {
      try {
        this.recognition.abort()
      } catch (e) {}
    }

    this.setState({ voiceState: 'paused', interimTranscript: '' })
  }

  resumeVoiceListening = () => {
    if (!this.state.isVoiceMode) return

    this.setState({
      voiceState: 'listening',
      interimTranscript: '',
      voiceTranscript: '',
    })

    // Chrome needs a brief pause after abort() before recognition can restart.
    setTimeout(() => {
      if (this.state.isVoiceMode && this.state.voiceState === 'listening') {
        this.startVoiceListening()
      }
    }, 150)
  }

  // Stop bot playback/processing and reopen the mic for a new user message.
  interruptBotAndStartListening = () => {
    if (!this.state.isVoiceMode) return

    this.voiceRequestGeneration += 1
    this.lastSpokenTtsText = ''

    if (this.synthesis) {
      try { this.synthesis.cancel() } catch (e) {}
    }
    this.stopAudio()
    this.stopVoiceCapture()
    this.clearVoiceWatchdog()

    this.setState({
      voiceState: 'listening',
      interimTranscript: '',
      voiceTranscript: '',
      isSpeaking: false,
      currentlyPlayingId: null,
    })

    // Chrome needs a brief pause after abort() before recognition can restart.
    setTimeout(() => {
      if (this.state.isVoiceMode && this.state.voiceState === 'listening') {
        this.startVoiceListening()
      }
    }, 150)
  }

  // VOICE MODE: Pause/resume listening (tap to interrupt)
  // CONTINUOUS MODE: Routes by this.voiceEngine
  toggleVoiceListening = () => {
    const { voiceState } = this.state

    if (voiceState === 'speaking' || voiceState === 'thinking') {
      this.interruptBotAndStartListening()
      return
    }

    if (voiceState === 'listening') {
      this.pauseVoiceListening()
      cl('Paused - recognition will not auto-restart')
    } else if (voiceState === 'paused') {
      this.resumeVoiceListening()
      cl('Resumed listening')
    }
  }
  
  // VOICE MODE: Submit voice transcript to bot API
  handleVoiceModeSubmit = async (transcript) => {
    if (!transcript || !transcript.trim()) return

    if (this.isLikelyBotEcho(transcript)) {
      cl('Ignoring echo transcript:', transcript)
      if (this.state.isVoiceMode) {
        this.setState({ voiceState: 'listening', interimTranscript: '', voiceTranscript: '' })
        this.startVoiceListening()
      }
      return
    }

    this.stopVoiceCapture()

    const requestId = ++this.voiceRequestGeneration

    // Set thinking state so voice capture stays off during the API call
    this.setState({ 
      voiceState: 'thinking',
      voiceTranscript: transcript
    })
    
    // Prepare request (same as text chat)
    const pageType = this.getPageTypeFromURL()
    let data = await this.loadPageData(pageType)
    
    const isAICommandMode = pageType === "setpoints" || pageType === "temp_stages" || pageType === "hum_dehum"
    if (isAICommandMode) {
      globs.commandMode = true
    } else {
      globs.commandMode = false
    }
    
    const body = { 
      messages: [{ role: "user", content: transcript }], 
      type: "command", 
      data: data, 
      thread_id: (globs.userData.session.sessionId).toString(), 
      pageType: pageType
    }
    
    // Add to chat history
    globs.chatBotHistory.push({question: transcript, answer: "thinking...", type: undefined})
    this.setState({
      chatHistory: [...this.state.chatHistory, {question: transcript, answer: "thinking...", type: undefined}]
    })
    
    try {
      // VOICE MODE: Call bot API (same endpoint as text chat)
      const apiUrl = `${this.state.host}/api/v1/lgvc/prompt`
      const botCommandResp = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
      
      if (!botCommandResp.ok) {
        throw new Error('API call failed')
      }
      
      const botResp = await botCommandResp.json()
      if (requestId !== this.voiceRequestGeneration) {
        cl('Ignoring stale voice API response after user interrupt')
        return
      }

      const botMessages = botResp.messages || []

      // Get bot response — start TTS fetch immediately (overlaps tool handling).
      const lastBotMsg = botMessages[botMessages.length - 1]
      const botAnswer = lastBotMsg?.content || "Sorry, I couldn't process that."
      const messageId = globs.chatBotHistory.length - 1
      const cleanAnswer = cleanMarkdown(botAnswer)
      const ttsPrefetchPromise = cleanAnswer && cleanAnswer.trim()
        ? this.prefetchVoiceTts(cleanAnswer, messageId, requestId)
        : null
      
      // Handle tool commands if present
      const toolMsgIndex = botMessages.findIndex(
        msg => msg.role === "tool" && msg.input && msg.input.status === "pending"
      )
      
      if (toolMsgIndex !== -1) {
        const toolMsg = botMessages[toolMsgIndex]
        const args = toolMsg.input.tool_input
        const toolName = toolMsg.input.tool
        const cmd = this.makeCmdName(toolName)
        args.cmd = cmd
        this.handleCmd(args)
      }

      // Keep "thinking..." until TTS is ready, then reveal text + play together (same as text mode).
      await this.speakVoiceResponse(botAnswer, ttsPrefetchPromise, messageId)
      
    } catch (error) {
      cl('Voice mode API error:', error)
      if (requestId !== this.voiceRequestGeneration) {
        return
      }
      
      const errorMsg = "Sorry, I'm having trouble connecting. Please try again."
      const messageId = globs.chatBotHistory.length - 1
      const cleanError = cleanMarkdown(errorMsg)
      const errorTtsPrefetch = cleanError && cleanError.trim()
        ? this.prefetchVoiceTts(cleanError, messageId, requestId)
        : null

      await this.speakVoiceResponse(errorMsg, errorTtsPrefetch, messageId)
    }
  }
  
  // VOICE MODE: Same server TTS as text read-aloud. Reveal answer when audio is ready (matches text mode).
  speakVoiceResponse = async (text, ttsPrefetchPromise = null, messageId = null) => {
    if (!this.state.isVoiceMode) return

    const cleanText = cleanMarkdown(text)
    const msgId = messageId != null ? messageId : Math.max(0, globs.chatBotHistory.length - 1)

    if (!cleanText || !cleanText.trim()) {
      globs.chatBotHistory[msgId].answer = text
      this.setState(prevState => {
        const updatedChatHistory = [...prevState.chatHistory]
        if (updatedChatHistory[msgId]) {
          updatedChatHistory[msgId].answer = text
        }
        return { chatHistory: updatedChatHistory, voiceState: 'listening' }
      }, () => {
        this.startVoiceListening()
      })
      return
    }

    this.lastSpokenTtsText = cleanText
    this.stopVoiceCapture()
    this.stopVoiceWaveMonitor()

    const session = ++this.ttsGeneration
    this.stopPlaybackOnly()
    this.unlockAudioPlayback()

    try {
      const audioBlob = await this.resolveTtsAudioBlob(cleanText, msgId, {
        ttsPrefetchPromise,
        voiceRequestId: this.voiceRequestGeneration,
      })

      if (session !== this.ttsGeneration) return

      if (!audioBlob) {
        globs.chatBotHistory[msgId].answer = text
        this.setState((prevState) => {
          const updatedChatHistory = [...prevState.chatHistory]
          if (updatedChatHistory[msgId]) {
            updatedChatHistory[msgId].answer = text
          }
          return {
            chatHistory: updatedChatHistory,
            voiceState: 'listening',
            isSpeaking: false,
            currentlyPlayingId: null,
          }
        })
        this.startVoiceListening()
        return
      }

      // Reveal answer and start playback at the same time (same timing as text mode auto-read).
      globs.chatBotHistory[msgId].answer = text
      this.playbackMessageId = msgId
      this.setState((prevState) => {
        const updatedChatHistory = [...prevState.chatHistory]
        if (updatedChatHistory[msgId]) {
          updatedChatHistory[msgId].answer = text
        }
        return {
          chatHistory: updatedChatHistory,
          voiceState: 'speaking',
          interimTranscript: '',
          isSpeaking: true,
          currentlyPlayingId: msgId,
        }
      })

      // Same playback path as text-mode speaker button (cached blob, identical server voice).
      await this.speakWithServerTts(cleanText, msgId, session)
    } catch (err) {
      if (session !== this.ttsGeneration) return
      cl('CONTINUOUS MODE: server TTS failed', err)
      globs.chatBotHistory[msgId].answer = text
      if (this.state.isVoiceMode) {
        this.playbackMessageId = null
        this.setState((prevState) => {
          const updatedChatHistory = [...prevState.chatHistory]
          if (updatedChatHistory[msgId]) {
            updatedChatHistory[msgId].answer = text
          }
          return {
            chatHistory: updatedChatHistory,
            isSpeaking: false,
            currentlyPlayingId: null,
            voiceState: 'listening',
          }
        })
        this.startVoiceListening()
      }
    }
  }
  // REDESIGN: Extract user initials for avatar display
  getUserInitials = () => {
    const name = this.username || "You";
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  render() {
      const {loading, question, answer, message, pageType, documents, isSpeaking, isCompactLayout} = this.state;
      // cl("🚀 ~ ChatBotUI ~ render state:", this.state)
      // cl("globs--------------", globs.chatBotHistory)
      // cl([this.state.currentlyPlayingId])
      //  const showCommandToggle = window.location.pathname.includes("/setpoints/") || window.location.pathname.includes("/temp_Staging/");
       const isAICommandMode = window.location.pathname.includes("/setpoints/") || window.location.pathname.includes("/temp_Staging/") || window.location.pathname.includes("/HumDeHum/");
       // REDESIGN: Get user initials for cleaner avatar
       const userInitials = this.getUserInitials();
      return (
      <div style={{
        height: "100%",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative"
      }}>
        {/* {this.state.showToast && this.state.toastMsg && (
        <div className="chatbot-toast-message">
          {this.state.toastMsg}
        </div>
        )} */}

      <div className="cbFormWrap"  style={{ 
        overflow: 'hidden', 
        flex: 1,
        display: 'flex', 
        flexDirection: 'column', 
        maxWidth: '100%', 
        width: '100%',
        minHeight: 0,
        position: 'relative'
      }}>
        {/* REDESIGN: Simplified header - tabs remain for functionality but styling can be adjusted via CSS */}
        <C18SubMenuHeader00 parms={{
              items: this.menuItems,
              pageType: this.state.pageType,
            onChange: o=>this.onChange(o),
         }}/>
        {pageType === 'Chat' && (
            <form onSubmit={this.handleSubmitPrompt} style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '100%',
              overflow: 'hidden',
              minHeight: 0
            }} method="POST">
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  maxWidth: '100%',
                  minHeight: 0
                }}>
                  {/* REDESIGN: Simplified header - removed italic "Powered By AI", cleaner typography */}
                  <h3 className="cb-chat-header"> 
                    Link4 ChatBot 
                    <span className="cb-chat-header-ai">AI</span>
                  </h3>

                  {/* Scrollable Chat Section */}
                  {/* VOICE MODE: Add bottom padding when voice mode is active */}
                <div className="chat-messages" ref={this.chatMessagesEndRef}  style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    minHeight: 0,
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    paddingBottom: '20px',
                    paddingTop: "8px",
                    scrollbarWidth: "thin", 
                    WebkitScrollbar: {
                      width: "8px",
                    },
                    boxSizing: "border-box"
                  }}>
                    {/* REDESIGN: Bot welcome message with cleaner layout */}
                  <div className="cbHost" style={{display: 'flex', alignItems: 'flex-start', marginBottom: '16px', gap: '10px'}}>
                    {/* REDESIGN: Simplified bot icon - smaller, cleaner */}
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      background: '#1f8ded',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <img src="/img/spark-white.png" style={{width: '20px', height: '20px'}} alt="bot" />
                    </div>
                    <div style={{flex: 1, minWidth: 0, maxWidth: 'calc(100% - 46px)'}}>
                      {/* REDESIGN: Removed separate name label, integrated into message bubble */}
                      <div className="cb-msg-bubble">
                        <p>Hi! How may I help you?</p>
                      </div>
                    </div>
                  </div>

                    {/* History Loop */}
                  {globs.chatBotHistory.map((item, index) => (
                    <React.Fragment key={index}>
                        {/* REDESIGN: User Message - right-aligned with initials avatar */}
                      <div className="cbHost cbGuest" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '16px',
                        gap: '10px',
                        flexDirection: 'row-reverse',
                        justifyContent: 'flex-start'
                      }}>
                        {/* REDESIGN: User avatar - initials in colored circle with solid color */}
                        <div style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          background: '#8b5cf6',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#fff'
                        }}>
                          {userInitials}
                        </div>
                        {/* REDESIGN: User message bubble - right-aligned with same colors as bot */}
                        <div className="cb-msg-bubble">
                          <p>{item.question}</p>
                        </div>
                      </div>

                        {/* REDESIGN: Bot Response - left-aligned on light gray */}
                      <div className="cbHost" style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '16px',
                        gap: '10px',
                        position: 'relative',
                        maxWidth: '100%'
                      }}>
                        {/* REDESIGN: Bot avatar - cleaner circular icon */}
                        <div style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          background: '#1f8ded',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}>
                          <img src="/img/spark-white.png" style={{width: '20px', height: '20px'}} alt="bot" />
                        </div>
                        <div style={{flex: 1, minWidth: 0, maxWidth: 'calc(100% - 46px)'}}>
                          {/* REDESIGN: Bot message bubble - light gray background */}
                          <div className="cb-msg-bubble">
                            <div className="cbAns" style={{margin: 0, maxWidth: '100%'}}>
                              {item.answer === "thinking..." ? (
                                <div style={{display: 'flex', gap: '4px', alignItems: 'center', padding: '4px 0'}}>
                                  <span style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: '#888',
                                    display: 'inline-block',
                                    animation: 'dotBounce 1.4s infinite ease-in-out',
                                    animationDelay: '0s'
                                  }}></span>
                                  <span style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: '#888',
                                    display: 'inline-block',
                                    animation: 'dotBounce 1.4s infinite ease-in-out',
                                    animationDelay: '0.2s'
                                  }}></span>
                                  <span style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: '#888',
                                    display: 'inline-block',
                                    animation: 'dotBounce 1.4s infinite ease-in-out',
                                    animationDelay: '0.4s'
                                  }}></span>
                                </div>
                              ) : (
                                <Markdown>{item.answer}</Markdown>
                              )}
                            </div>
                          </div>
                          {/* REDESIGN: Feedback icons always visible with 44px+ touch targets */}
                          <div className="replyReaction" style={{
                            display: 'flex',
                            gap: '4px',
                            marginTop: '6px',
                            alignItems: 'center',
                            maxWidth: '100%',
                            flexWrap: 'nowrap',
                            justifyContent: 'flex-start'
                          }}>
                            {(item.type === 1 || item.type === undefined) && (
                                <span onClick={() => this.handleTypeChange(
                                      1,
                                      index,
                                      item.question,
                                      item.answer
                                    )
                                  }
                                  className="thUp lBtn"
                                  style={{
                                    cursor: 'pointer',
                                    minWidth: '44px',
                                    minHeight: '44px',
                                    width: '44px',
                                    height: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                  }}>
                                  <svg
                                    viewBox="0 -960 960 960"
                                    fill={item.type ? "#8b5cf6" : "#5f6368"}
                                    style={{width: '20px', height: '20px'}}
                                  >
                                  <path d="M720-120H280v-520l280-280 50 50q7 7 11.5 19t4.5 23v14l-44 174h258q32 0 56 24t24 56v80q0 7-2 15t-4 15L794-168q-9 20-30 34t-44 14Zm-360-80h360l120-280v-80H480l54-220-174 174v406Zm0-406v406-406Zm-80-34v80H160v360h120v80H80v-520h200Z" />
                                </svg>
                              </span>
                            )}
                            {(item.type === 0 || item.type === undefined) && (
                                <span onClick={() => this.handleTypeChange( 0, index, item.question, item.answer )}
                                  className="thDn lBtn"
                                  style={{
                                    cursor: 'pointer',
                                    minWidth: '44px',
                                    minHeight: '44px',
                                    width: '44px',
                                    height: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                  }}>
                                  <svg
                                    viewBox="0 -960 960 960"
                                    fill={item.type === 0 ? "#8b5cf6" : "#5f6368"}
                                    style={{width: '20px', height: '20px'}}
                                  >
                                  <path d="M240-840h440v520L400-40l-50-50q-7-7-11.5-19t-4.5-23v-14l44-174H120q-32 0-56-24t-24-56v-80q0-7 2-15t4-15l120-282q9-20 30-34t44-14Zm360 80H240L120-480v80h360l-54 220 174-174v-406Zm0 406v-406 406Zm80 34v-80h120v-360H680v-80h200v520H680Z" />
                                </svg>
                              </span>
                            )}
                              {/* REDESIGN: Volume Icon with minimum touch target */}
                            <span 
                            onClick={() => this.handleReadLoud(item.answer, index)}
                            style={{ 
                              cursor: "pointer",
                              minWidth: '44px',
                              minHeight: '44px',
                              width: '44px',
                              height: '44px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}
                           >
                          {this.state.currentlyPlayingId === index ? (
                          <Stop style={{ color: "#5f6368", fontSize: '20px' }} />
                            ) : (
                          <VolumeUp style={{ color: "#5f6368", fontSize: '20px' }} />
                          )}
                          </span>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                  
                  {/* VOICE MODE: Live transcript bubble (dashed border) while listening */}
                  {this.state.isVoiceMode && this.state.interimTranscript && (
                    <div className="cbHost cbGuest" style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: '16px',
                      gap: '10px',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      opacity: 0.7
                    }}>
                      <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: '#8b5cf6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#fff'
                      }}>
                        {userInitials}
                      </div>
                      <div className="cb-msg-bubble cb-msg-bubble--interim" style={{
                        color: '#666',
                        border: '2px dashed #ccc',
                        fontStyle: 'italic'
                      }}>
                        <p>{this.state.interimTranscript}</p>
                      </div>
                    </div>
                  )}
                </div>

                {/* REDESIGN: Integrated input bar with mic button merged inside */}
                {/* VOICE MODE: Hide text input bar when voice mode is active */}
                {!this.state.isVoiceMode && (
                <div className="cb-chat-compose">
                  <div className="cb-chat-input-shell">
                    <textarea
                      value={message}
                      onChange={(e) => this.handleInputChange(e, "Chat")}
                      className="cbtextArea"
                      placeholder="Type your message..."
                      style={{ 
                        fontSize: "15px",
                        flex: 1,
                        border: 'none',
                        background: 'transparent',
                        resize: 'none',
                        outline: 'none',
                        maxHeight: '120px',
                        minHeight: '24px',
                        fontFamily: 'inherit',
                        lineHeight: '1.5',
                        minWidth: 0
                      }}
                      rows={1}
                    ></textarea>

                    <div style={{minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                      <VoiceRecorder
                        onTranscript={this.handleVoiceTranscript}
                        onSend={this.handleVoiceSend}
                        host={this.state.host}
                        stopAudio={this.stopAudio}
                        unlockAudioPlayback={this.unlockAudioPlayback}
                        inline={true}
                        onEnterVoiceMode={this.enterVoiceMode}
                      />
                    </div>

                    <div style={{minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                      <button
                        type="submit"
                        className={`sendButton${loading ? ' sendButton--loading' : ''}`}
                        aria-label="Send message"
                        disabled={loading}
                        style={{
                          background: '#8b5cf6',
                          border: 'none',
                          borderRadius: '50%',
                          width: '40px',
                          height: '40px',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: loading ? 0.6 : 1,
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                          boxShadow: '0 2px 8px rgba(139, 92, 246, 0.3)'
                        }}
                        onMouseEnter={(e) => !loading && (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                )}
              </div>
            </form>
          )}
        {pageType === 'Documents' && (
            <div className="cbfileWrap">
              <div className="ui-doc cbFileTab">
                <div className="cb-doc-header">
                  <div className="cb-doc-header-actions">
                    {this.renderDocSyncAction()}
                    {this.renderDocUploadAction()}
                  </div>
                </div>
          {this.state.documentsLoading ? (
            <div className="cb-doc-loading" role="status" aria-live="polite">
              <div className="cb-doc-loading-dots" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>
              <span className="cb-doc-loading-label">Loading documents...</span>
            </div>
                ) : (
                  <div className="cbFileInner">
              <form onSubmit={this.handleSubmitDocument} method='POST'>
                      <ul className="document-list docTabWrap">
                        {documents.map((doc, index) => (
                  <li key={index} className="document-item" onClick={()=>this.handleLoadDocument(doc)}>
                            <h3 className="docTab">{doc.name}</h3>
                            <div className="docActions">
                              {doc.path ? (
                      <a href={doc.type === "local" ? `${this.state.host}/api/v1/prompt/download/${doc.name}` : doc.path} target="_blank" rel="noopener noreferrer">
                       <span className="viewIcon"><svg height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg></span>
                      </a>)
                      :
                      <span className="viewIcon"><svg height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg></span>

                      }
                              {doc.type === "local" ? (
                       <span className="delIcon" onClick={e=>this.handleDeleteDocument(doc)}><svg height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg></span>
                              ) : null}
                       
                    {/*  </a> */}
                      
                            </div>
                    {/* )} */}
                          </li>
                        ))}
                        <li className="document-item">
                          <h3 className="docTab">Link4 AI Internal Manual</h3>
                          <div className="docActions">
                    <a target="_blank" rel="noopener noreferrer" href='https://docs.google.com/document/d/1qBY1mwTl0eCcbAPf4KzhchwdqsOYwsuR1pAuMeQVpCQ/edit?usp=sharing'><span className="viewIcon"><svg height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg></span>
                            </a>
                          </div>
                        </li>
                      </ul>
                    </form>
                  </div>

                )}
              </div>
            </div>
          )}
        </div>
        
        {/* VOICE MODE: Bottom bar contained within chatbot panel */}
        {this.state.isVoiceMode && (
          <div className="voice-mode-bottom-bar">
            <div className="voice-mode-status">
              {this.state.voiceState === 'listening' && 'Listening...'}
              {this.state.voiceState === 'thinking' && 'Thinking… Tap mic to interrupt'}
              {this.state.voiceState === 'speaking' && 'Speaking… Tap mic to interrupt'}
              {this.state.voiceState === 'paused' && 'Tap to speak'}
            </div>

            <div className="voice-mode-controls">
              <button
                type="button"
                className="voice-mode-side-btn"
                onClick={this.exitVoiceMode}
                aria-label="Switch to keyboard"
                title="Switch to keyboard"
              >
                <Keyboard style={{ fontSize: 22 }} />
              </button>

              <div className="voice-mode-mic-wrap">
                {this.state.voiceState === 'listening' && (
                  <div className="voice-mode-mic-ring" aria-hidden="true" />
                )}
                <button
                  type="button"
                  className={
                    'voice-mode-mic-button ' +
                    (this.state.voiceState === 'listening'
                      ? 'voice-mode-mic-button--listening'
                      : this.state.voiceState === 'speaking' || this.state.voiceState === 'thinking'
                        ? 'voice-mode-mic-button--active'
                        : 'voice-mode-mic-button--paused')
                  }
                  onClick={this.toggleVoiceListening}
                  aria-label={
                    this.state.voiceState === 'listening' ? 'Pause listening' :
                    this.state.voiceState === 'paused' ? 'Start listening' :
                    this.state.voiceState === 'speaking' || this.state.voiceState === 'thinking'
                      ? 'Stop bot and speak'
                      : 'Interrupt bot'
                  }
                >
                  {this.state.voiceState === 'listening' ? (
                    <div className="voice-mode-wave cb-voice-wave-bars voice-mode-wave--live" aria-hidden="true">
                      {(this.state.voiceWaveLevels || [0.15, 0.15, 0.15, 0.15, 0.15]).map((level, barIndex) => (
                        <div
                          key={barIndex}
                          className="bar"
                          style={{ height: `${Math.round(8 + level * 20)}px` }}
                        />
                      ))}
                    </div>
                  ) : (
                    <Mic style={{
                      fontSize: 32,
                      color: this.state.voiceState === 'paused' ? '#888' : '#fff'
                    }} />
                  )}
                </button>
              </div>

              <button
                type="button"
                className="voice-mode-side-btn"
                onClick={this.exitVoiceMode}
                aria-label="Close voice mode"
                title="Close voice mode"
              >
                <Close style={{ fontSize: 22 }} />
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }
}
// no need for now. this function updates the textfile in the backend
// handleSubmitDocument = async (e) => {
//   e.preventDefault();
//   const resp = await fetch(`${this.state.host}/api/v1/prompt/updateDoc`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ message: this.state.docText }),
//     })
//   cl("handleSubmitDocument", this.state.docText)
//   this.setState({toastMsg: "Document updated", showToast: true});
//   this.hideToast()
// }
